import { SecurityData } from '../models/security-data.model'

/**
 * Create display string for a distribution's security asset id
 */
export function displaySecurityAssetId(securityData: SecurityData): string {
  return `Distributions for AssetId: ${securityData.assetId}`
}

export function displaySecurityDescription(
  securityData: SecurityData,
  hasLlaRates = false,
): string {
  const { description, securityType, supportLevel } = securityData
  const legend = hasLlaRates ? ' (* values sourced from LLA)' : ''
  const source = hasLlaRates ? `${supportLevel}*` : supportLevel

  return `Type: ${securityType}, Accrued from: ${source}${legend}, Description: ${description}`
}
